import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-dyanmic-fields',
  templateUrl: './dyanmic-fields.component.html',
  styleUrls: ['./dyanmic-fields.component.scss'],
})
export class DyanmicFieldsComponent implements OnInit {

  @Input() allow_client = true;
  @Input() allow_project = true;
  @Input() allow_task = true;
  @Input() allow_step = true;
  @Input() allow_firm = true;
  @Input() allow_user = true;
  @Input() allow_company = true;
  @Input() allow_mention = false;
  // null = access not restricted (everyone shown as accessible)
  @Input() mention_access: { guid: string, has_access: boolean }[] | null = null;
  @Input() compact_mode = true;
  @Input() warning_message = '';

  @Output() fieldSelected = new EventEmitter<string>();
  @Output() mentionSelected = new EventEmitter<{ guid: string, display_name: string }>();

  activeCategory: string | null = null;

  mentionSearch = '';
  teamMembers: any[] = [];
  loadingTeamMembers = false;

  readonly fieldCategories = [
    {
      key: 'contact', label: 'Contact', btnClass: 'btn-secondary', badgeClass: 'bg-secondary',
      fields: [
        'contact.display_name', 'contact.email', 'contact.first_name', 'contact.last_name',
        'contact.middle_name', 'contact.title', 'contact.suffix', 'contact.phone',
        'contact.cell_phone', 'contact.alt_phone', 'contact.fax', 'contact.address',
        'contact.city', 'contact.province', 'contact.country', 'contact.postal_code',
        'contact.website', 'contact.custom_id', 'contact.gender', 'contact.date_of_birth',
        'contact.anniversary', 'contact.sin', 'contact.spoken_language',
        'contact.fiscal_year_end', 'contact.notes', 'contact.description',
      ]
    },
    {
      key: 'company', label: 'Company', btnClass: 'btn-info', badgeClass: 'bg-info text-dark',
      fields: [
        'company.name', 'company.phone', 'company.fax', 'company.website',
        'company.address', 'company.address_2', 'company.city', 'company.province',
        'company.postal_code', 'company.country', 'company.corp_name',
        'company.business_number', 'company.fiscal_year_end', 'company.type',
        'company.industry', 'company.custom_id', 'company.description',
      ]
    },
    {
      key: 'project', label: 'Project', btnClass: 'btn-success', badgeClass: 'bg-success',
      fields: [
        'project.title', 'project.description',
        'project.internal_start_date', 'project.internal_start_month', 'project.internal_start_day', 'project.internal_start_year',
        'project.internal_end_date', 'project.internal_end_month', 'project.internal_end_day', 'project.internal_end_year',
        // 'project.client_start_date', 'project.client_start_month', 'project.client_start_day', 'project.client_start_year',
        // 'project.client_end_date', 'project.client_end_month', 'project.client_end_day', 'project.client_end_year',
        'project.period_start_date', 'project.period_start_month', 'project.period_start_day', 'project.period_start_year',
        'project.period_end_date', 'project.period_end_month', 'project.period_end_day', 'project.period_end_year',
      ]
    },
    {
      key: 'task', label: 'Task', btnClass: 'btn-warning', badgeClass: 'bg-warning text-dark',
      fields: [
        'task.title', 'task.description',
        'task.start_date', 'task.start_month', 'task.start_day', 'task.start_year',
        'task.due_date', 'task.due_month', 'task.due_day', 'task.due_year',
      ]
    },
    {
      key: 'action', label: 'Action', btnClass: 'btn-danger', badgeClass: 'bg-danger',
      fields: ['action.title', 'action.description']
    },
    {
      key: 'firm', label: 'Firm', btnClass: 'btn-dark', badgeClass: 'bg-dark',
      fields: ['firm.name']
    },
    {
      key: 'user', label: 'User', btnClass: 'btn-primary', badgeClass: 'bg-primary',
      fields: ['user.display_name', 'user.email']
    },
    {
      key: 'mention', label: 'Team Member', btnClass: 'btn-primary', badgeClass: 'bg-primary',
      fields: []
    },
  ];

  constructor(public globalService: GlobalService) { }

  ngOnInit() {}

  InsertField(field: string) {
    this.fieldSelected.emit(field);
  }

  toggleCategory(key: string) {
    this.activeCategory = this.activeCategory === key ? null : key;
    if (this.activeCategory === 'mention') {
      this.mentionSearch = '';
      this.LoadTeamMembers();
    }
  }

  // Team member tagging is the only thing on offer (no placeholders to insert)
  get only_mention(): boolean {
    return this.allow_mention && !this.allow_client && !this.allow_company && !this.allow_project
      && !this.allow_task && !this.allow_step && !this.allow_firm && !this.allow_user;
  }

  isCategoryAllowed(key: string): boolean {
    switch (key) {
      // A company's own default contact still lives under contact.* fields - if companies are
      // allowed but clients aren't, show the category anyway (just relabeled, see GetCategoryLabel).
      case 'contact':  return this.allow_client || this.allow_company;
      case 'company': return this.allow_company;
      case 'project': return this.allow_project;
      case 'task':    return this.allow_task;
      case 'action':  return this.allow_step;
      case 'firm':    return this.allow_firm;
      case 'user':    return this.allow_user;
      case 'mention': return this.allow_mention;
      default:        return true;
    }
  }

  activeCategoryDef() {
    return this.fieldCategories.find(c => c.key === this.activeCategory) || null;
  }

  // "Contact" only means "client" when clients are actually allowed here - when it's showing
  // solely because companies are allowed, it really represents that company's default contact.
  GetCategoryLabel(cat: { key: string, label: string }): string {
    if (cat.key === 'contact' && !this.allow_client) return 'Default Contact';
    return cat.label;
  }

  async LoadTeamMembers() {
    if (this.teamMembers.length > 0 || this.loadingTeamMembers) return;
    this.loadingTeamMembers = true;
    this.teamMembers = await this.globalService.GetTeamMembersList() || [];
    this.loadingTeamMembers = false;
  }

  filteredTeamMembers() {
    if (!this.mentionSearch) return this.teamMembers;
    const search = this.mentionSearch.toLowerCase();
    return this.teamMembers.filter(member => (member.display_name || '').toLowerCase().includes(search));
  }

  InsertMention(member: any) {
    if (!this.HasMentionAccess(member)) return;
    this.mentionSelected.emit({ guid: member.guid, display_name: member.display_name });
    this.activeCategory = null;
    this.mentionSearch = '';
  }

  HasMentionAccess(member: any): boolean {
    if (!this.mention_access) return true;
    const entry = this.mention_access.find(a => a.guid === member.guid);
    return entry ? entry.has_access : true;
  }
}
